import React from "react"
import { NavLink } from "react-router-dom";
import { SocialIcon } from 'react-social-icons';
import './NavBar.css';

export default function NavBar() {
    return (
        <header className="bg-blue-800 navbar">
            <div className="container mx-auto flex justify-between">
                <nav className="flex">
                    <NavLink to="/"
                     exact
                     activeClassName="text-yellow"
                     className="inflex-flex items-center py-6 px-3 mr-4 text-white hover:text-gray-800 text-4xl font-bold cursive tracking-widest">
                        WDHN
                    </NavLink>
                    <NavLink to="/post" className="inflex-flex items-center py-3 px-3 rounded my-6 text-red-200 hover:text-gray-300"
                    activeClassName="text-red-100 bg-blue-900"
                    >
                        Blog Post
                    </NavLink>
                    <NavLink to="/project" className="inflex-flex items-center py-3 px-3 rounded my-6 text-red-200 hover:text-gray-300"
                    activeClassName="text-red-100 bg-blue-900"
                    >
                        Projects
                    </NavLink>
                    <NavLink to="/about" className="inflex-flex items-center py-3 px-3 rounded my-6 text-red-200 hover:text-gray-300"
                    activeClassName="text-red-100 bg-blue-900"
                    >
                        About
                    </NavLink>
                    <NavLink to="/contact" className="inflex-flex items-center py-3 px-3 rounded my-6 text-red-200 hover:text-gray-300"
                    activeClassName="text-red-100 bg-blue-900"
                    >
                        Contact
                    </NavLink>
                </nav>
                <div className="inflex-flex py-3 px-3 my-6">
                <SocialIcon url="https://linkedin.com/in/henry-nwadiogor-744026a8" 
                className="mr-4" target="_blank" fgColor="#fff" style={{ height: 35, width: 35 }}/>
                <SocialIcon url="https://twitter.com/henrysmith5" 
                className="mr-4" target="_blank" fgColor="#fff" style={{ height: 35, width: 35 }}/>
                <SocialIcon url="https://github.com/henry-49" 
                className="mr-4" target="_blank" fgColor="#fff" style={{ height: 35, width: 35 }}/>
                </div>
            </div>
        </header>
    )
}
